class Property {
  /**
   * Constructs a Property object.
   * 
   * @param {String} ident 
   * @param {*} values - array or a string
   */
  constructor(ident, values) {
    this.ident = ident;
    if (!Array.isArray(values)) {
      if (values && values.length) {
        values = [values];
      } else {
        values = [];
      }
    }
    this.values = values.filter(v => v && v.toString().length > 0).sort();
  }

  /**
   * Returns the first value or undefined if value is not set.
   */
  get value() {
    return this.values && this.values.length > 0 ? this.values[0] : undefined;
  }

  /**
   * Returns the number of values.
   */
  get length() {
    return this.values ? this.values.length : 0;
  }

  /**
   * Adds a value.
   * 
   * @param {*} value 
   */
  add(value) {
    if (!(this.contains(value))) {
      this.values.push(value);
      this.values = this.values.sort();
    }
    return this;
  }

  /**
   * Removes a value.
   * 
   * @param {*} value 
   */
  remove(value) {
    this.values = this.values.filter(v => v !== value);
    return this;
  }

  /**
   * Returns true if contains the specified value; false otherwise.
   * 
   * @param {*} value 
   * @returns true if contains the specified value; false otherwise
   */
  contains(value) {
    return this.values.some(val => val === value);
  }

  isEmpty() {
    return this.length === 0;
  }

  isMoveBlack() {
    return this.ident === "B";
  }

  isMoveWhite() {
    return this.ident === "W";
  }

  toString() {
    if (this.value) {
      return this.values.reduce((str, value) =>
        str + "[" + value + "]", this.ident
      );
    } else {
      return this.ident + "[]";
    }
  }
}

export default Property;